import { Spinner } from '@seddi/ui-kit';
import React, { FC } from 'react';
import * as S from './homeWait.styles';

export const HomeWait: FC = () => {
  return (
    <S.Wrapper>
      <Spinner type="star" />
    </S.Wrapper>
  );
};
